module.exports = __webpack_public_path__ + "267c3a0883d9cb2181495e50a4850615.jpg";